const frequency = 'weeks';

function formatAmount(amount) {
	return `$${amount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}`;
}

function errorMinAmount(config, period) {
	$('#inputAmount').addClass('error');
	$('#inputAmountError').html(`Minimum purchase for interest free is ${formatAmount(config.minAmount[period])}`);
}

function checkAmount(config, amount, period) {
	if (amount === 0) {
		return false;
	} else if (amount < config.minAmount[period]) {
		errorMinAmount(config, period);
		return false;
	}

	return true;
}

function resetAmount() {
	$('#inputAmount').removeClass('error');
	$('#inputAmountError').html('');

	$('span#repayment').html(formatAmount(0));
	$('span#total').html(formatAmount(0));
	$('span#frequency').html(frequency);
}

function updateRepayments(config, amount, frequency, period) {
	let repayments = 0;

	if (frequency === 'month') {
		repayments = amount / period;
	} else if (frequency === 'week') {
		repayments = amount / config.weeks[period];
	}

	const totalAmount = repayments ? parseFloat(amount) + Math.ceil(parseInt(period) / 12) * 99 : 0;
	$('span#repayment').html(formatAmount(repayments));
	$('span#total').html(formatAmount(totalAmount));
	$('span#frequency').html(frequency);
}

function getAmount() {
	return $('input[name="amount"]')
		.val()
		.replace(/[^0-9.]/, '');
}

module.exports = function() {
	if ($('#calculator').length) {
		const options = $('#calculator').data('options');
		const config = {
			minAmount: {},
			weeks: {
				60: 260,
				50: 216.4,
				36: 156,
			},
		};

		for (let i = 0; i < options.length; i++) {
			const option = options[i];
			config.minAmount[option.months] = option.minSpend;
		}
		
		const period = $('select[name="period"]').val();
		const minSpend = config.minAmount[period];

		$('div#minimumSpend').html(
			`<i class="fa fa-exclamation-circle"></i> Minimum purchase ${formatAmount(minSpend)}`,
		);

		$('input[name="amount"]').on('change', function() {
			resetAmount();
			const amount = getAmount();
			const frequency = $('select[name="frequency"]').val();
			const period = $('select[name="period"]').val();

			if (!checkAmount(config, amount, period)) {
				return;
			}

			if (amount && frequency && period) {
				updateRepayments(config, amount, frequency, period);
			}
		});

		$('select[name="period"]').on('change', function() {
			resetAmount();
			const amount = getAmount();
			const frequency = $('select[name="frequency"]').val();
			const period = $('select[name="period"]').val();
			const minSpend = config.minAmount[period];

			$('div#minimumSpend').html(
				`<i class="fa fa-exclamation-circle"></i> Minimum purchase: ${formatAmount(minSpend)}`,
			);

			if (!checkAmount(config, amount, period)) {
				return;
			}

			if (amount && frequency && period) {
				updateRepayments(config, amount, frequency, period);
			}
		});

		$('select[name="frequency"]').on('change', function() {
			const amount = getAmount();
			const frequency = $('select[name="frequency"]').val();
			const period = $('select[name="period"]').val();

			if (amount && frequency && period) {
				updateRepayments(config, amount, frequency, period);
			}
		});
	}
};
